<template>
  <div id="home" class="main">
    <!-- 头部 -->
    <Header index="1" @change="headertap"></Header>
    <div class="content">
       <!--[if lte IE 9]>
            <p class="browserupgrade">You are using an <strong>outdated</strong> browser. Please <a href="https://browsehappy.com/">upgrade your browser</a> to improve your experience and security.</p>
        <![endif]-->

        <!-- Add your site or application content here -->  

        <!-- prealoder area start -->
        <!-- <div id="loading">
            <div id="loading-center">
                <div id="loading-center-absolute">
                <div class="object" id="first_object"></div>
                <div class="object" id="second_object"></div>
                <div class="object" id="third_object"></div>
                </div>
            </div>      
        </div> -->
        <!-- prealoder area end -->

     
        <div class="body-overlay transition-3"></div>
        <!-- extra info area end -->

        <main>
           
            <section
                    class="page__title p-relative d-flex align-items-center"
                    data-background="assets/img/page-title/page-title-1.jpg"
                    :style="'background-image:url(' + allurl + bannerimg + ')'"
                >
                    <div class="container">
                    <div class="row">
                        <div class="col-xl-12">
                        <div class="page__title-inner text-center">
                            <h1>Products</h1>
                            <div class="page__title-breadcrumb">
                            <nav aria-label="breadcrumb">
                                <ol class="breadcrumb justify-content-center">
                                <li class="breadcrumb-item">
                                    <a @click="goindex">Home</a>
                                </li>
                                <li class="breadcrumb-item active" aria-current="page">
                                   shop
                                </li>
                                </ol>
                            </nav>
                            </div>
                        </div>
                        </div>
                    </div>
                    </div>
                </section>
              
            <!-- slider area end -->

            <!-- banner area start -->
           
            <!-- banner area end -->

            <!-- product area start -->
            
            
            <section class="product__area pt-60 pb-100">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-12">
                           <div class="shop__header d-sm-flex justify-content-between flex-sb align-items-center mb-40">
                                    <div class="shop__header-left">
                                        <div class="show-text">
                                            <span :class="menuctive==0?'active':''" @click="addchoose(0)"><b>&nbsp; All &nbsp;</b>   </span>&nbsp;
                                            
                                            <span :class="menuctive==index+1?'active':''" @click="addchoose(index+1)" v-for="(items,index) in menuchoose" :key="index"><i> |&nbsp;</i><b>{{items}}</b> </span>
                                           
                                        </div>
                                    </div>
                                    <div class="shop__header-right  align-items-center ">
                                        <!-- {{getbranddata.title}} -->
                                        <el-select @change="shoptype"  v-model="getbranddata.ex_title" placeholder="请选择" style="min-width:300px">
                                            <!-- <el-option  label="所有商品" value="所有商品"> </el-option> -->
                                            <el-option
                                            v-for="item in options"
                                           
                                            
                                            :key="item.id"
                                            :label="item.ex_title"
                                            :value="item.id">
                                            </el-option>
                                        </el-select>
                                        <!-- <ul class="nav nav-pills" id="pills-tab" role="tablist">
                                            <li class="nav-item">
                                                <a class="nav-link active" id="pills-grid-tab" data-toggle="pill" href="#pills-grid" role="tab" aria-controls="pills-grid" aria-selected="true"><i class="fas fa-th"></i></a>
                                            </li>
                                            <li class="nav-item">
                                                <a class="nav-link" id="pills-list-tab" data-toggle="pill" href="#pills-list" role="tab" aria-controls="pills-list" aria-selected="false"><i class="fas fa-list-ul"></i></a>
                                            </li>
                                        </ul> -->
                                    </div>
                                </div>
                        </div>
                    </div>
                    <div class="row"> 
                        <div class="col-xl-12">
                            <div class="product__slider owl-carousel">
                                <div class="product__item col-xl-3 col-lg-3 col-md-6 col-xs-6" v-for="(items,index) in shoplist" v-loading="shopload" @click="viewnews(items.id)" :key="index">
                                    <div class="product__wrapper mb-60">
                                        <div class="product__thumb">
                                            <!-- {{items}} -->
                                            <a class="w-img">
                                                <img :src="allurl+items.image" alt="product-img">
                                                <!-- <img class="product__thumb-2" :src="allurl+items.image" alt="product-img"> -->
                                            </a>
                                            <div class="product__action transition-3">
                                                <a  data-toggle="tooltip" data-placement="top" title="Add to Wishlist">
                                                    <i class="fa fa-heart-o"></i>
                                                </a>
                                                <a  data-toggle="tooltip" data-placement="top" title="Compare">
                                                    <i class="fa fa-sliders"></i>
                                                </a>
                                                <!-- Button trigger modal -->
                                                <a  data-toggle="modal" data-target="#productModalId">
                                                    <i class="fa fa-search"></i>
                                                </a>

                                            </div>
                                        </div>
                                        <div class="product__content p-relative">
                                            <div class="product__content-inner">
                                                <h4><a>{{items.ex_title}}</a></h4>
                                                <h4><a>{{items.title}}</a></h4>
                                                <div class="product__price transition-3">
                                                    <span>${{items.money}}</span>
                                                    <span class="old-price">{{items.money==items.price||items.price==0?'':'$'+items.price}}</span>
                                                </div>
                                            </div>
                                            <div class="add-cart p-absolute transition-3">
                                                <a class="point">+ Add to Cart</a>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>
                                <div class="product__item " v-if="shoplist==''" style="width:100%">
                                    <div class="text-center" style="height:100px;line-height: 100px;">
                                        <p class="text-center">暂无商品</p>
                                    </div>
                                </div>
                               
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xl-12">
                            <!-- <div class="product__load-btn text-center mt-25">
                                <a  class="os-btn os-btn-3">Load More</a>
                            </div> -->
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :page-size="getbranddata.limit"
                                background
                                layout="prev, pager, next"
                                :total="total">
                            </el-pagination>
                        </div>
                    </div>
                </div>
               
            </section>
            <!-- product area end -->

             <!-- page title area start -->
           
            <!-- page title area end -->

            <!-- shop area start -->
           
            <!-- shop area end -->
            <!-- banner area start -->
           
            <!-- banner area end -->

            <!-- sale off area start -->
            
            <!-- sale off area end -->

            <!-- client slider area start -->
            
            <!-- client slider area end -->

            <!-- blog area start -->
            
            <!-- blog area end -->
 
            <!-- subscribe area start -->
            
            <!-- subscribe area end -->

            <!-- shop modal start -->
            <!-- Modal -->
            
                   
            <!-- shop modal end -->
        </main>

        
    </div>
    <!-- 底部 -->
    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "../../components/footer.vue";
import Header from "../../components/header.vue";

import { getbrand,getindex, getgoodstype } from "@/api/index/index";
 
export default {
  components: { Header, Footer },
  name: "home",
  data() {
    return {
      currentIndex: "",
      teacherIndex: '',
      ishove:true,
      menuctive:0,
      activeBtn: 2,
      shopload:false,
      clickIndex: 0,
      shoplist:[],
      bannerimg:[],
      lanmuhe:'',
    //   <span>New product &nbsp;|&nbsp; </span>
    //                                         <span>Discount |&nbsp; </span>
    //                                         <span>Rxpenditures </span>
      menuchoose:['Hot','Sale','Recommend'],
      options: [],
      total:1,
      value:'',
      typeid:1,
      getbranddata:{
        page:1,
        brake:'0',
        goodstype_id:0,
        title:'All Type',
        limit:8,
      },
      
      leftIcon: require("../../assets/left.png"),
      rightIcon: require("../../assets/right-active.png"),

    };
  },
  mounted () {
    // let video = document.getElementsByClassName('video')
    // video.play()
    // 滚动条的获取
    console.log('刚进入')
    if(this.$route.query.id){
        this.getbranddata.goodstype_id=this.$route.query.id    
    }
    console.log(this.getbranddata.goodstype_id)
   this.getgoodtype()
    this.getgootype()
    
 
  },
  onshow() {
      console.log('onshow改变');
     this.getgoodtype()
    this.getgootype()
  },
  created(){
    //   console.log('滚动高度', window.pageYOffset)  
  },
  
  methods: {
    getgoodtype(){
        getindex().then((res)=>{
            
            this.options=res.goodstype
            this.options.unshift({id:0,title:'所有商品',ex_title:'All Type'})
            console.log(this.options)
             if(this.getbranddata.goodstype_id){
                 if(this.getbranddata.goodstype_id==0){
                     this.getbranddata.title='所有商品'
                     this.getbranddata.ex_title='All Type'
                 }else if(this.getbranddata.goodstype_id==1){
                     this.getbranddata.title='家居&厨房'
                     this.getbranddata.ex_title='Home & Kitchen'
                 }else if(this.getbranddata.goodstype_id==2){
                     this.getbranddata.title='花园&户外'
                     this.getbranddata.ex_title='Garden & Outdoor'
                  }else if(this.getbranddata.goodstype_id==4){
                     this.getbranddata.title='康养&运动'
                     this.getbranddata.ex_title='Health & Sport'
                 }else if(this.getbranddata.goodstype_id==6){
                     this.getbranddata.title='工具&车用物件'
                     this.getbranddata.ex_title='Tools & Car'
                 }else if(this.getbranddata.goodstype_id==5){
                    //  this.getbranddata.title='智能生活'
                 }
             }
        
        })
    },
    viewnews(id) {
        // this.$router.push({ name: "newsview" });
        this.$router.push({ name: "productview", query: { id } });
    },
    goindex(){
      this.$router.push({ name: "home" });
    },
    getgootype(){
        this.shopload=true
        console.log(this.getbranddata.goodstype_id,'执行分类')
        getbrand(this.getbranddata).then((res)=>{
            this.shoplist=res.goods
            this.shopload=false
            this.total=res.total
        })
        getgoodstype().then((res) => {
        this.bannerimg = res.banner[0].image;
        console.log(res)
      });
    },
    handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
        this.getbranddata.page=val
        this.getgootype()
        console.log(`当前页: ${val}`);
    },
    shoptype(id){
        console.log(id,'id值')
        
        this.getbranddata.goodstype_id=id
        console.log(this.getbranddata.goodstype_id,'goodstype_id值')
        // this.typeid=
        if(this.getbranddata.goodstype_id==0){
            this.$router.push({ name: "shop" });
        }else{
            this.$router.push({ path: "/shop", query:  {id}  });//这里 
           
        }
        console.log(this.getbranddata.goodstype_id,'选择了分类')
        this.getbranddata.page=1
        this.getgoodtype()
        this.getgootype()
        

        // if(this.getbranddata.title=='所有商品'){
        //     this.getbranddata.goodstype_id=0
        //      this.getbranddata.brake=0
        //     this.menuctive=0
        //     this.getgootype()
        // }else if(this.getbranddata.title=='家居&厨房'){
        //     this.getbranddata.goodstype_id=1
        //      this.getbranddata.brake=0
        //     this.menuctive=0
        //     this.getgootype()
        // }else if(this.getbranddata.title=='花园&户外'){
        //     this.getbranddata.goodstype_id=2
        //     this.getbranddata.brake=0
        //     this.menuctive=0
        //     this.getgootype()
        // }else if(this.getbranddata.title=='康养&运动'){
        //     this.getbranddata.goodstype_id=3
        //     this.getbranddata.brake=0
        //     this.menuctive=0
        //     this.getgootype()
        // }else if(this.getbranddata.title=='工具&车用物件'){  
        //     this.getbranddata.goodstype_id=4
        //     this.getbranddata.brake=0
        //     this.menuctive=0
        //     this.getgootype()
        // }else if(this.getbranddata.title=='智能生活'){  
        //     this.getbranddata.goodstype_id=5
        //     this.getbranddata.brake=0
        //     this.menuctive=0
        //     this.getgootype()
        // }
    
        
       
            // console.log(this.getbranddata.brake)
    },
    addchoose(code){
        this.menuctive = code;
        this.getbranddata.brake=code
        this.getgootype()
        console.log(this.getbranddata)
    },
    changestyle(index) {
      this.currentIndex = index;
    },
    
    originstyle() {
      this.currentIndex = "";
    },
    
    // 事件处理函数
    async headertap(event){
        console.log(event)
        this.getbranddata.goodstype_id=event
        this.getgoodtype()
        this.getgootype()
        console.log( this.getbranddata);
    },
    clicktap(index) {
      this.clickIndex = index;
    },
    arrowClick(val) {
      if (val === "right") {
        this.$refs.cardShow.next();
        console.log(val)
        this.activeBtn = 2;
        this.rightIcon = require("../../assets/right-active.png");
        this.leftIcon = require("../../assets/left.png");
      } else {
        this.$refs.cardShow.prev();
        console.log(val)
        this.activeBtn = 1;
        this.leftIcon = require("../../assets/left-active.png");
        this.rightIcon = require("../../assets/right.png");
      }
    },
    changehandle (currentIndex,originIndex) {
      console.log(currentIndex,originIndex)
    },
    // 移入事件
    delHandleMouseEnter(index) {
        this.teacherIndex = index
    },
    // 移出
    delHandleMouseleave(){ 
        this.teacherIndex = ''
    }
  }
};
</script>

<style scoped lang='less'>
    .banner__area{z-index: 100;}
    .owl-carousel{display: flex;    flex-wrap: wrap;}
    .product__area .product__thumb a{display: block;}
    .col-xl-20{width:20%}
    // .col-lg-20{width:20%}
     .col-md-20{width:20%}
     .col-xs-6{width:50%}
     .content{background:#f1f1f1}
// .sale__area{background:#f1f1f1}
.product__area .product__slider>.col-xs-6{width:50%}
.product__item{padding:5px;margin:0}


 .product__content{padding:5px 10px}
.product__wrapper{background:#fff;padding-bottom:40px;border-radius: 5px;overflow: hidden;}
.section__title h2{background:#f1f1f1}
    @media (min-width: 768px){
         .col-md-20 {
            -ms-flex: 0 0 20%;
            -webkit-box-flex: 0;
            flex: 0 0 20%;
            max-width: 20%;
        }
       
    }
    @media (min-width: 990px){
         .col-md-20 {
            -ms-flex: 0 0 20%;
            -webkit-box-flex: 0;
            flex: 0 0 20%;
            max-width: 20%;
        }
        .col-lg-20{-ms-flex: 0 0 20%;
            -webkit-box-flex: 0;
            flex: 0 0 20%;
            max-width: 20%;}
       .col-xl-20 {
            -ms-flex: 0 0 20%;
            -webkit-box-flex: 0;
            flex: 0 0 20%;
            max-width: 20%;
         }
    }
    @media (max-width: 480px){
         .product__wrapper{margin-bottom: 0;}
    }

 

        //  .col-xl-20
    .sale__item a{display: block;}
    .banner__item{padding:10px;width:100%;background:#ccc;text-align: left;}
    .link-btn{border:2px solid #bc8246;border-radius: 10px;padding:1px 2px;text-transform: none;}
    .show-text span{cursor: pointer;}
    .show-text b{padding:1px 5px;margin:0 5px}
    
    .show-text .active b{background:#bc8246;border-radius: 10px;color:#fff}
    .product__content-inner h4{
            white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    text-align: left
    }
    /deep/ .el-pagination.is-background .el-pager li:not(.disabled).active{
        background-color: #bc8246;
}
    .product__thumb .w-img img:hover{transform: scale(1.1)}
    // .shop__header-right{width:100%}
    // .mt--95{margin-top: -150px;}
    // @import "../../assets/css/preloader.css";
    // @import "../../assets/css/bootstrap.min.css";
    // @import "../../assets/css/slick.css";
    // @import "../../assets/css/owl.carousel.min.css";
    // @import "../../assets/css/animate.min.css";
    // @import "../../assets/css/jquery.fancybox.min.css";
    // // @import "../../assets/css/fontAwesome5Pro.css";
    // // @import "../../assets/css/ionicons.min.css";
    // @import "../../assets/css/default.css";
    // @import "../../assets/css/style.css";
    // <link rel="stylesheet" href="../../assets/css/preloader.css">
        // <link rel="stylesheet" href="../../assets/css/bootstrap.min.css">
        // <link rel="stylesheet" href="../../assets/css/slick.css">
        // <link rel="stylesheet" href="../../assets/css/metisMenu.css">
        // <link rel="stylesheet" href="../../assets/css/owl.carousel.min.css">
        // <link rel="stylesheet" href="../../assets/css/animate.min.css">
        // <link rel="stylesheet" href="../../assets/css/jquery.fancybox.min.css">
        // <link rel="stylesheet" href="../../assets/css/fontAwesome5Pro.css">
        // <link rel="stylesheet" href="../../assets/css/ionicons.min.css">
        // <link rel="stylesheet" href="../../assets/css/default.css">
        // <link rel="stylesheet" href="../../assets/css/style.css">
</style>



// WEBPACK FOOTER //
// src/views/shop/shop.vue